import React from 'react'

const ViewProject = () => {
    return (
        <div>
            <div className="modal fade" id="viewProjectModal" tabindex="-1" aria-labelledby="viewProjectModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-xl">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title font-bold" id="viewProjectModalLabel">Project Information</h5>
                            <button type="button" className="btn-close btn-close-primary size-10" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            {/* Card for Basic Details */}
                            <div className="card mb-3">
                                <div className="">
                                    <h6 className="section-title">Basic Details:</h6>
                                </div>
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-md-6">
                                            <label className="form-label">Name:</label>
                                            <p>Project ABC</p>
                                        </div>
                                        <div className="col-md-6">
                                            <label className="form-label">Code:</label>
                                            <p>ABC123</p>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-6 mt-3">
                                            <label className="form-label">Sub Title:</label>
                                            <p>Amazing Project</p>
                                        </div>
                                        <div className="col-md-6 mt-3">
                                            <label className="form-label">Address:</label>
                                            <p>123 Street Name, City</p>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-6 mt-3">
                                            <label className="form-label">Brochure:</label>
                                            <p>link-to-brochure.com</p>
                                        </div>
                                        <div className="col-md-6 mt-3">
                                            <label className="form-label">Walkthrough:</label>
                                            <p>link-to-walkthrough.com</p>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-6 mt-3">
                                            <label className="form-label">Virtual Tour:</label>
                                            <p>link-to-tour.com</p>
                                        </div>
                                        <div className="col-md-6 mt-3">
                                            <label className="form-label">Website:</label>
                                            <p>projectwebsite.com</p>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-6 mt-3">
                                            <label className="form-label">Location:</label>
                                            <p>City, Country</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Card for Contact Details */}
                            <div className="card mb-3">
                                <div className="card-header">
                                    <h6 className="font-semibold mb-0">Contact Details:</h6>
                                </div>
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-md-6 mt-3">
                                            <label className="form-label">WhatsApp No:</label>
                                            <p>+1234567890</p>
                                        </div>
                                        <div className="col-md-6 mt-3">
                                            <label className="form-label">Mobile No:</label>
                                            <p>+0987654321</p>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-6 mt-3">
                                            <label className="form-label">Instagram:</label>
                                            <p>@project_instagram</p>
                                        </div>
                                        <div className="col-md-6 mt-3">
                                            <label className="form-label">Facebook:</label>
                                            <p>facebook.com/project</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>

                        <div className="modal-footer justify-content-between p-3" style={{ borderTop: "2px solid #f0f0f0" }}>
                            <button
                                type="button"
                                className="btn btn-outline-primary d-flex align-items-center gap-2"
                                style={{ borderRadius: "30px", padding: "0.5rem 1.5rem" }}
                                data-bs-dismiss="modal"
                            >
                                <i className="bi bi-x-circle"></i> Close
                            </button>
                        </div>
                    </div>
                </div>
            </div>




        </div>
    )
}

export default ViewProject
